import { useState, useEffect } from "react";

const useInactivityTimer = (timeout = 30 * 60 * 1000) => {
  // 30 minutes in milliseconds
  const [isInactive, setIsInactive] = useState(false);

  useEffect(() => {
    let inactivityTimer;

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      setIsInactive(false);
      inactivityTimer = setTimeout(() => {
        setIsInactive(true);
      }, timeout);
    };

    // Events to track
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
    ];

    // Add event listeners
    events.forEach((event) => {
      document.addEventListener(event, resetTimer);
    });

    // Initial timer
    resetTimer();

    // Cleanup
    return () => {
      clearTimeout(inactivityTimer);
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [timeout]);

  return isInactive;
};

export default useInactivityTimer;
